
import {Options, Vue} from 'vue-class-component';
import {Button, TextInput} from '@timenaut/timenaut-vue-common'
import {defaultPriceInfo, getPriceDetails} from "@/util/price_fetch_util"
import { redirectToStripeCheckout } from '@/util/auth_util';

@Options({
  components: {
    TextInput,
    Button
  }
})
export default class FreeProductDescription extends Vue {
  priceInfo = defaultPriceInfo;

  redirectToStripeCheckout = redirectToStripeCheckout;

  mounted() {
    getPriceDetails().then(result => {
      this.priceInfo = result
    });
  }
}
